import React, { useEffect, useState } from 'react'
import { getAllData } from '../../services/tasks/tasks'
import { useParams } from 'react-router-dom'
import { GoSearch } from 'react-icons/go';
import { Form } from 'react-bootstrap';
function Members(props) {
  const [search, setSearch] = useState("")
  let { id } = useParams();
  const [getData, setGetData] = useState([]);
  const getApiData = () => {
    getAllData(id)
      .then(res => {
        var userFilter = res.data.data.filter((id) => id.userId === localStorage.getItem("userId"))
        var newFilter = userFilter.map((item) => item.member.map((em) => em.email))
        setGetData(newFilter);
      }).catch(e => {
        console.error("Err :", e);
      })
  }
  useEffect(() => {
    getApiData();
  }, [])

  console.log("props : ", getData[0]);
  let userId = localStorage.getItem("userId");

  return (
    <>
      <div className="container mt-1">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-dark">Members</h3>
              </div>
              <Form className="d-flex me-2">
                <span className="searchicon" style={{ marginTop: "10px", fontSize: "15px" }}>
                  <GoSearch />
                </span>

                <Form.Control
                  type="search"
                  placeholder="Search"
                  className="control"
                  aria-label="Search"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Form>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped table-vcenter">
                    <thead>
                      <tr>
                        <th style={{ width: "50px" }}>#</th>

                        <th>Email</th>
                        {/* <th className="d-none d-sm-table-cell" style={{ width: "30%" }}>Role</th>
                        <th className="d-none d-sm-table-cell" style={{ width: "30%" }}>Status</th>
                        <th className="d-none d-sm-table-cell" style={{ width: "30%" }}>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        getData[0]?.filter((data) => {
                          return search.toLowerCase() == '' ?
                            data : data.toLowerCase().includes(search)
                        }).map((item, index) => {
                          console.log(item)
                          return (
                            <tr key={index}>
                              <td style={{ color: "white" }}>{index + 1}</td>
                              <td style={{ color: "white" }}>{item}</td>
                              {/*
                            <td className="d-none d-sm-table-cell">
                              <em className="text-muted">{item.description}</em>
                            </td>
                            <td className="d-none d-sm-table-cell">
                              <em className="text-muted">{item.userId}</em>
                            </td>
                            <td className="d-none d-sm-table-cell">
                              <em className="text-muted">{item._id}</em>
                            </td>
                            <td className="d-none d-sm-table-cell">
                              <em className="text-muted">{item._id}</em>
                            </td> */}
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default Members